module.exports = __webpack_public_path__ + "static/img/used_tag.b9dfa58c.png";